// app/javascript/controllers/index.js
import { Application } from "@hotwired/stimulus";
import { Alert, Dropdown, Modal, Tabs, Popover, Toggle, Slideover } from "tailwindcss-stimulus-components";

// Start Stimulus
const application = Application.start();



// // controllers/index.js

// import { application } from "./application"

// Load all controllers matching *_controller.js recursively
import controllers from "./**/*_controller.js"

// 🔍 Add this line to confirm controllers are being loaded
console.log("Stimulus controllers loaded:", controllers)

controllers.forEach((controller) => {
  application.register(controller.name, controller.module.default)
})



// // ✅ Register your custom controller manually
// import TypeaheadController from "./typeahead_controller";
// application.register("typeahead", TypeaheadController);

// // ✅ Register your custom controller manually
// import TypeaheadController from "./typeahead_controller";
// application.register("typeahead", TypeaheadController);

// ✅ Tailwind Stimulus components
application.register("alert", Alert);
application.register("dropdown", Dropdown);
application.register("modal", Modal);
application.register("tabs", Tabs);
application.register("popover", Popover);
application.register("toggle", Toggle);
application.register("slideover", Slideover);
